import { effect, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly router = inject(Router);
  private readonly _loading = signal(false);
  readonly loading = this._loading.asReadonly();

  private loadingCount = 0;
  private readonly routerEvent = toSignal(this.router.events);

  constructor() {
    effect(() => {
      const event = this.routerEvent();
      if (event instanceof NavigationStart) {
        this.show();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) this.hide();
    });
  }

  show(): void {
    this.loadingCount++;
    if (this.loadingCount === 1) {
      this._loading.set(true);
    }
  }

  hide(): void {
    this.loadingCount--;
    if (this.loadingCount === 0) {
      this._loading.set(false);
    }
  }

  reset(): void {
    this.loadingCount = 0;
    this._loading.set(false);
  }
}
